import React from 'react';
import { FaFacebookF, FaTwitter, FaGooglePlusG } from 'react-icons/fa';
import './Footer.css';


const Footer = () => {
    return (
        <div className='footer'>
            <div className='container'>
                <div className="row">
                    <div className="col-md-3">
                        <p className='mt-5'>Emergency Dental care</p>
                        <p>Check Up</p>
                        <p>Treatment of personal Diseases</p>
                        <p>Tooth Extraction</p>
                        <p>Check Up</p>
                    </div>
                    <div className="col-md-3">
                        <h4 className='head-color'>Services</h4>
                        <p className='mt-4'>Emergency Dental care</p>
                        <p>Check Up</p>
                        <p>Treatment of personal Diseases</p>
                        <p>Tooth Extraction</p>
                        <p>Check Up</p>
                        <p>Check Up</p>
                        <p>Check Up</p>
                    </div>
                    <div className="col-md-3">
                        <h4 className='head-color'>Oral Heath</h4>
                        <p className='mt-4'>Emergency Dental care</p>
                        <p>Check Up</p>
                        <p>Treatment of personal Diseases</p>
                        <p>Tooth Extraction</p>
                        <p>Check Up</p>
                        <p>Check Up</p>
                        <p>Check Up</p>

                    </div>
                    <div className="col-md-3">
                        <h4 className='head-color'>Our Address</h4>
                        <p className='mt-4'>New York - 101010 Hudson Yard</p>
                        <div className='d-flex mt-5 pt-5'>
                            <div className='fa-icon'><FaFacebookF /></div>
                            <div className='fa-icon'><FaTwitter /></div>
                            <div className='fa-icon'><FaGooglePlusG /></div>
                        </div>
                        <p className='mt-5 pt-5 mb-1'>Call Now</p>
                        <button className='btn-similar'>+2025515621</button>
                    </div>
                </div>
            </div>
            <p className='text-center mt-5'>Copyright {new Date().getFullYear()} All Rights Reserved</p>
        </div>
    );
};

export default Footer;